import { render, staticRenderFns } from "./CourseGradebook.vue?vue&type=template&id=02709889&scoped=true&"
import script from "./CourseGradebook.vue?vue&type=script&lang=js&"
export * from "./CourseGradebook.vue?vue&type=script&lang=js&"
import style0 from "./CourseGradebook.vue?vue&type=style&index=0&id=02709889&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02709889",
  null
  
)

export default component.exports